export default __webpack_public_path__ + "static/nathan_kowalski_resume-490dafa1e66514c9d645852f7ce19d9f.pdf";